module.exports = __webpack_public_path__ + "static/media/T14-T25-05-01.a3cb30b3.svg";